export default __webpack_public_path__ + "static/media/mp.fc6a2893.svg";